import { z } from "zod";
import { RoleFeeKindSchema } from "./assignments";

export const PerformerSchema = z.object({
  id: z.string(),
  name: z.string(),
  phoneNumber: z.string().nullable(),
  email: z.string().nullable(),
  notes: z.string().nullable(),
  bankName: z.string().nullable(),
  bankAccount: z.string().nullable(),
  accountName: z.string().nullable(),
  instructorId: z.string().nullable(),
  instructorName: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]),
  performerType: z
    .enum(["dancer", "choreographer", "kol", "other"])
    .default("other"),
  defaultRoleFeeKind: RoleFeeKindSchema.default("performer"),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type PerformerDTO = z.infer<typeof PerformerSchema>;

export const CreatePerformerSchema = z.object({
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່ນັກສະແດງ"),
  phoneNumber: z.string().nullable().optional(),
  email: z.string().email("ອີເມລບໍ່ຖືກຕ້ອງ").nullable().optional(),
  notes: z.string().nullable().optional(),
  bankName: z.string().nullable().optional(),
  bankAccount: z.string().nullable().optional(),
  accountName: z.string().nullable().optional(),
  instructorId: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]).default("active"),
  performerType: z
    .enum(["dancer", "choreographer", "kol", "other"])
    .default("other"),
  defaultRoleFeeKind: RoleFeeKindSchema.default("performer"),
});
export type CreatePerformerDTO = z.infer<typeof CreatePerformerSchema>;

export const UpdatePerformerSchema = z.object({
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່ນັກສະແດງ").optional(),
  phoneNumber: z.string().nullable().optional(),
  email: z.string().email("ອີເມລບໍ່ຖືກຕ້ອງ").nullable().optional(),
  notes: z.string().nullable().optional(),
  bankName: z.string().nullable().optional(),
  bankAccount: z.string().nullable().optional(),
  accountName: z.string().nullable().optional(),
  instructorId: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]).optional(),
  performerType: z.enum(["dancer", "choreographer", "kol", "other"]).optional(),
  defaultRoleFeeKind: RoleFeeKindSchema.optional(),
});
export type UpdatePerformerDTO = z.infer<typeof UpdatePerformerSchema>;
